import React from "react";
import s from "./serviceIntro.scss";
import { Icon, infoFill } from "../../icons/index";
import cx from "classnames";
import { Link } from "react-router-dom";
import sessionStore from "@/stores/session";

const ServiceIntro = ({ title, description, iconSvg, imageSvg, className }) => (
  <div className={cx("expand", s.serviceIntro, className)}>
    <Icon svg={iconSvg} height="2rem" width="2rem" />
    <div className={cx("expand", s.content)}>
      <div className={s.column}>
        <div className={s.title}>{title}</div>
        <div className={s.description} dangerouslySetInnerHTML={{ __html: description }} />
      </div>
      <div className={s.imageContainer}>
        <Icon className={s.image} svg={imageSvg} width="355" height="auto" />
      </div>
    </div>
  </div>
);

export default ServiceIntro;
